import {
    ReactElement,
    ButtonHTMLAttributes
} from "react";

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
    activeStep: number;
    step: number;
    onClick?: any;
    latestStep?: string;
    title?: string;
    children?: any
}
export function StepperItemMobile({ activeStep, step, onClick, latestStep, title, children }: Props): ReactElement {

    return (
        <>

            {children ?
                
                 <>

{children}
                 </>
             
             : 
             <div className={`${step > activeStep ? "mobile-step-deactive" : "mobile-step-active"} mobile-step`}></div>
            }


        </>
    )
}

export default StepperItemMobile;